import React from 'react';
import { ProfileStatus } from 'src/types/UserInfo';
import { useRouter } from 'next/router';
import { KatSpinner } from '@amzn/katal-react';
import { redirectToLoginPage } from 'src/utils/request';
import { useAppSelector } from 'src/redux/hooks';
import {
  FAQS,
  GUIDELINES,
  HOME_PAGE,
  THREAD_LISTING,
  getThreadDetail,
  GROUPS,
  getGroupListing,
  getUserProfileDetail,
  RELEASE_NOTES,
} from 'src/constants/pages';
import { AppState } from 'src/redux/store';
import { isGroupsVisibleForMpId } from 'src/utils';

// TODO: create types for route paths to use here and in hand with routeHistory
const publicRoutes = [
  HOME_PAGE,
  THREAD_LISTING,
  getThreadDetail('[threadId]'),
  FAQS,
  GUIDELINES,
  RELEASE_NOTES,
  GROUPS,
  getGroupListing('[groupId]'),
];

const RouteProtector = ({ children }: any) => {
  const { pathname, push, query } = useRouter();
  const { profileStatus, userId } = useAppSelector(({ userInfo }) => userInfo);
  const selectedMarketplaceId = useAppSelector(
    ({ userInfo }: AppState) => userInfo.selectedMarketplaceId,
  );

  if (profileStatus === ProfileStatus.unauthenticated && !publicRoutes.includes(pathname)) {
    redirectToLoginPage();
    return <KatSpinner data-testid="spinner" />;
  }
  const redirectionValidations = [
    {
      path: GROUPS,
      validate: () => !isGroupsVisibleForMpId(selectedMarketplaceId)
      && HOME_PAGE,
    },
    {
      path: getUserProfileDetail('[userId]'),
      validate: () => {
        const { userId: profileId } = query as { userId: string };
        return !profileId && getUserProfileDetail(userId!);
      },
    },
    {
      path: getThreadDetail('[threadId]'),
      validate: () => {
        const { threadId } = query as { threadId: string };
        return !threadId && THREAD_LISTING;
      },
    },
    {
      path: getGroupListing('[groupId]'),
      validate: () => {
        const { groupId } = query as { groupId: string };
        if (!isGroupsVisibleForMpId(selectedMarketplaceId)) {
          return HOME_PAGE;
        }
        return !groupId && GROUPS;
      },
    },
  ];
  const redirectionPath = redirectionValidations.find(
    (redirectionValidation) => redirectionValidation.path === pathname,
  )?.validate();
  if (redirectionPath) {
    push(redirectionPath);
    return <KatSpinner />;
  }
  return React.Children.map(children, (child) => <div key={child.type.name}>{child}</div>);
};
export default RouteProtector;
